//
// webPollPrefilledUrl
//
// The link a campaign personalises: one parameter per contact field the poll asks
// for, each value a placeholder the sender replaces with its own variable. The
// address comes first, a '#' left in a later value taking every parameter after it
//
import webPollUrl from './webPollUrl';

const addressFirst = (a, b) => ((a === 'email') ? -1 : ((b === 'email') ? 1 : 0));

const webPollPrefilledUrl = (qrid, getInfo) => {
  const fields = (getInfo ?? [])
    .filter((thisCode) => (thisCode !== 'emailOrPhone'))
    .sort(addressFirst);

  if (!fields.length) return undefined;

  return `${webPollUrl(qrid)}?${fields.map((thisCode) => (`${thisCode}=[${thisCode}]`)).join('&')}`;
};

export default webPollPrefilledUrl;
